export const HOST = process.env.REACT_APP_API_URL || 'https://cdn-dev.kiemdinhoto.vn'
export const ZALO_HOST = 'http://zalo.ttdkapi.ttdk.com.vn'
export const IMAGE_HOST = HOST + 'upload/'
export const ALERT_SERVICE_FIRST_PAGE = '/automated-traffic-fine-notification/vehicles'
export const ALERT_SERVICE_SECOND_PAGE = '/automated-traffic-fine-notification/services'
export const ALERT_SERVICE_THIRD_PAGE = '/automated-traffic-fine-notification/payment'